export default __webpack_public_path__ + "static/media/EditIcon.16214f41.svg";